import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const PassengerForm = styled.div``;

export const CTA = styled.div`
  margin-top: ${({ theme }) => theme.spacing.x5};
`;

export const Button = styled.button`
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    width: 100%;
  }
`;
export const HiddenForm = styled.form`
  display: none;
`;
